import { spmConfig } from '@/constant/spm';

export const getSpmConfig = (dataLoader) => {
  try {
    const params = spmConfig[dataLoader?.data?.pathname];
    console.log(process.env.ICE_EXE_ENV, '环境变量-ICE_EXE_ENV');
    const ICE_EXE_ENV = process.env.ICE_EXE_ENV || 'production';
    const isPush = () => ['release', 'production'].includes(ICE_EXE_ENV);
    if (params && isPush()) {
      const { spmB, ...reset } = params || {};
      return {
        spm: {
          spmB,
          ...reset,
        },
      };
    } else {
      return {};
    }
  } catch (error) {
    console.error('获取SPM配置失败:', error);
    return {};
  }
};
